type NavigatorWithConnection = Navigator & {
  connection?: { saveData?: boolean };
};

/**
 * Whether the hero clip may start by itself.
 *
 * Not when the OS asks for reduced motion, and not on a connection with
 * Save-Data on: the clip is decoration and a few megabytes the reader did not
 * ask for. Either way the poster stays and the pause button offers play.
 * Neither API is in every browser (jsdom has no matchMedia, Safari has no
 * connection), and a missing one means no preference was expressed.
 */
export function shouldAutoplayHeroVideo(): boolean {
  if (typeof window === "undefined") return false;
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches) {
    return false;
  }
  const connection = (navigator as NavigatorWithConnection).connection;
  return connection?.saveData !== true;
}
